<button
  (click)="propagateClick($event)"
  [disabled]="disabled"
  [ngClass]="cssClasses"
  [type]="action"
  class="button"
>
  <ng-content></ng-content>
</button>
